import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import CustomerTable from "../components/CustomerTable";
import { Spinner } from "react-bootstrap";

const CustomerPage = () => {
    const [data,setData] = useState([]);
    const [loading,setLoading] = useState(false);
    const fetchUser  = async () =>{
      setLoading(true)
        let headerList = {
            Accept: "*/*",
            "Content-type": "application/json",
          };
          const response = await fetch(
            API_URL+`/api/customer/fetch`,
            { method: "GET", headers: headerList }
          );
          const dataFor = await response.json();
          setLoading(false)
          if (response.status === 201) {
              
              setData(dataFor.customer)
            
          }
    }   
    React.useEffect(()=>{
        fetchUser()
    },[1])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Customers" />

        {/* TableDataLayer */}
        {
          loading ===true ?
          <div className="text-center mt-4">
            <Spinner/>
          </div>: null
        }
         {
            data.length === 0 &&  loading ===false ?
            <p>No Customers Found....</p>:null
        }
        {
            data.length === 0 ? null :
        <CustomerTable  data={data.reverse()}/>
        }

      </MasterLayout>

    </>
  );
};

export default CustomerPage; 
